import { darken, transparentize } from "polished";

const PrimaryTheme = "#187A97";

export const Colors = {
  Grey700: "#424242",
};

const Theme = {
  PrimaryColor: PrimaryTheme,
  PrimaryDark: "#222f3e",
  PrimaryGrey: "#576574",
  PrimaryInputOutline: "#C6CADE",
  PrimaryLight: "#C8D6E5",
  PrimaryBorderColor: "#CBD5E4",
  SecondaryBorderColor: "#ECECEC",
  PrimaryRadius: "5px",
  PrimaryRed: "#fb5e9a",
  PrimaryOrange: "#E98B3A",
  PrimaryBlue: "#437DC1",
  PrimaryGreen: "#8FE2C9",
  noLabelUpperCase: true,
  PrimaryFont: "'Nunito', sans-serif",

  PrimaryFontSize: "13px",
  PrimaryFontColor: "#262E3D",
  SecondaryFontColor: "#8893A6",

  PrimarySurface: "#F2F4F6",
  SecondarySurface: "#f2f7fd",
  PrimaryFade: "#FAFAFA",

  AccentRed: "#EDA8F0",

  Elevate: {
    low: `box-shadow: 0 1px 3px ${transparentize(
      0.9,
      darken(0.2, PrimaryTheme)
    )}`,
    mid: `box-shadow: 1px 3px 6px ${transparentize(
      0.8,
      darken(0.3, PrimaryTheme)
    )}`,
    high: `box-shadow: 1px 6px 15px ${transparentize(
      0.8,
      darken(0.3, PrimaryTheme)
    )}`,
    fader: `box-shadow: 1px 1px 10px ${transparentize(
      0.9,
      darken(0.4, PrimaryTheme)
    )}`,
  },
};

export default Theme;
